import { nxConfig } from '@nv/utils'
import Keycloak from 'keycloak-js'

const REALM_NAME = nxConfig.KEYCLOAK_REALM_ADMIN
const keycloakConfig = {
  url: nxConfig.ADMIN_KEYCLOAK_URL,
  clientId: 'voter-portal',
  realm: REALM_NAME ? REALM_NAME : 'tivi',
}

const _kc = new Keycloak(keycloakConfig)

const initKeycloak = (onAuthenticatedCallback) => {
  _kc
    .init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      pkceMethod: 'S256',
    })
    .then((authenticated) => {
      if (!authenticated) {
        // console.log('user is not authenticated..!')
      } else {
        // console.log('user is authenticated.')
      }
      onAuthenticatedCallback(_kc)
    })
    .catch()
}

const doLogin = _kc.login
const doLogout = _kc.logout
const updateToken = (timeToExpiry) => _kc.updateToken(timeToExpiry)

const onTokenExpired = async (onSessionExpired, timeToExpiry) => {
  try {
    await _kc.updateToken(timeToExpiry)
  } catch (error) {
    onSessionExpired()
  }
}
const getToken = () => _kc.token
const isLoggedIn = () => !!_kc.token

const getUsername = () => _kc.tokenParsed?.preferred_username
const getParsedToken = () => _kc.tokenParsed
const getTokenParsed = () => _kc.tokenParsed
const hasRole = (role) => _kc.hasRealmRole(role)
const hasAnyOfRoles = (roles) => {
  for (var role of roles) {
    if (_kc.hasRealmRole(role)) {
      return true
    }
  }
  return false
}
const getSessionStartTime = () => _kc.tokenParsed?.auth_time

const isSuperAdmin = () => _kc.hasRealmRole('tivi-root-admin')
const isContactInfoRoleAdmin = () => _kc.hasRealmRole('tivi-contactinfo')
const isPollWorkerRoleAdmin = () => _kc.hasRealmRole('tivi-pollworker')
const isEventModuleAdmin = () => _kc.hasRealmRole('tivi-event-admin')
const isMonitoringAdmin = () => _kc.hasRealmRole('tivi-auditor')
const isVoterAdminDeveloper = () => _kc.hasRealmRole('voter-admin-developer')
const isEventAdminDeveloper = () => _kc.hasRealmRole('tivi-developer')

export const KeycloakAdminService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  hasRole,
  getParsedToken,
  getTokenParsed,
  onTokenExpired,
  getSessionStartTime,
  isSuperAdmin,
  isContactInfoRoleAdmin,
  isPollWorkerRoleAdmin,
  isEventModuleAdmin,
  isMonitoringAdmin,
  isVoterAdminDeveloper,
  isEventAdminDeveloper,
  hasAnyOfRoles,
}
